import { gtagGameToolEventPv } from '../../../../utils/gtagWrapper';
import { createApp } from 'vue';

import App from '@/App.vue';

import '@/css/common.scss';

(function (): void {
  function init(): void {
    const elements = document.querySelectorAll<HTMLElement>('.legends-arceus-move-search');
    elements.forEach(async (el) => {
      const app = createApp(App);
      app.mount(el);
      gtagGameToolEventPv('specific', 'move-search', 'legends-arceus');

      document.addEventListener(
        'kamigame-leaving-current-page',
        () => {
          app.unmount();
        },
        { once: true }
      );
    });
  }

  init();
})();
